import React from "react";
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,
  MDBTable,
  MDBTableHead,
  MDBTableBody,
  MDBBadge,
  MDBIcon,
  MDBInput,
} from "mdb-react-ui-kit";
import "./CategoriasModal.css";
import { doFetch } from "Projects/CC_cubi_clan_project/Utils/ConnectionManager";
import { CategoriaSuggestionModal } from "Projects/CCON_cubiconta_project/Components/CategoriaSuggestionModal/CategoriaSuggestionModal";

const DEFAULT_COLOR = "#aaaaaa";

export class CategoriasModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categorias: [],
      editingId: null,       // IDCategoria being edited
      editNombre: "",
      editColor: DEFAULT_COLOR,
      editEsIngreso: false,
      newNombre: "",
      newColor: DEFAULT_COLOR,
      newEsIngreso: false,
      showNewRow: false,
      deleteTarget: null,    // categoria pending delete confirmation
      suggestionState: null, // { suggestions, nombre, color, esIngreso, mode: 'add'|'rename', idCategoria }
      mergeState: null,      // { idCategoriaDestino, nombreDestino, nombre, color, esIngreso } from MERGE_REQUIRED
    };
  }

  normalizeIncomeFlag(value) {
    return value === true || value === 1 || value === "1";
  }

  componentDidMount() {
    this.loadCategorias();
  }

  loadCategorias() {
    this.props.onLoading(true);
    doFetch("CCON", "getAllCategorias", null)
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.setState({ categorias: data.DATA });
        }
      })
      .catch(console.error)
      .finally(() => this.props.onLoading(false));
  }

  startEdit(cat) {
    this.setState({
      editingId: cat.IDCategoria,
      editNombre: cat.nombre,
      editColor: cat.color || DEFAULT_COLOR,
      editEsIngreso: this.normalizeIncomeFlag(cat.esIngreso),
    });
  }

  cancelEdit() {
    this.setState({ editingId: null });
  }

  _searchSimilarAndThen(nombre, thenFn) {
    const opts = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ nombre }),
    };
    return doFetch("CCON", "searchSimilarCategorias", opts)
      .then((r) => r.json())
      .then((data) => {
        const suggestions = data.DATA?.sugerencias || [];
        thenFn(suggestions);
      })
      .catch(console.error);
  }

  _doAddCategoria(nombre, color, esIngreso, idCategoriaSugerida = null) {
    const payload = [{ nombre, color, esIngreso }];
    if (idCategoriaSugerida != null) payload[0].IDCategoriaSugerida = idCategoriaSugerida;
    this.props.onLoading(true);
    const opts = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    };
    doFetch("CCON", "insertCategorias", opts)
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.setState({ showNewRow: false, newNombre: "", newColor: DEFAULT_COLOR, newEsIngreso: false, suggestionState: null });
          this.loadCategorias();
        }
      })
      .catch(console.error)
      .finally(() => this.props.onLoading(false));
  }

  _doUpdateCategoria(id, nombre, color, esIngreso, confirmarMerge) {
    this.props.onLoading(true);
    const opts = {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ IDCategoria: id, Nombre: nombre, Color: color, EsIngreso: esIngreso, confirmarMerge }),
    };
    doFetch("CCON", "updateCategoria", opts)
      .then((r) => r.json())
      .then((data) => {
        if (data.STATE === "SUCCESS") {
          this.setState({ editingId: null, suggestionState: null, mergeState: null });
          this.loadCategorias();
        } else if (data.STATE === "MERGE_REQUIRED") {
          this.setState({
            suggestionState: null,
            mergeState: {
              idCategoriaDestino: data.DATA.idCategoriaDestino,
              nombreDestino: data.DATA.nombreDestino,
              nombre,
              color,
              esIngreso,
              idCategoria: id,
            },
          });
        }
      })
      .catch(console.error)
      .finally(() => this.props.onLoading(false));
  }

  saveEdit() {
    const { editingId, editNombre, editColor, editEsIngreso } = this.state;
    if (!editNombre.trim()) return;

    this.props.onLoading(true);
    this._searchSimilarAndThen(editNombre.trim(), (suggestions) => {
      this.props.onLoading(false);
      // Exclude the category being edited itself from suggestions
      const otherSuggestions = suggestions.filter((s) => s.IDCategoria !== editingId);
      if (otherSuggestions.length > 0) {
        this.setState({
          suggestionState: {
            suggestions: otherSuggestions,
            nombre: editNombre.trim(),
            color: editColor,
            esIngreso: editEsIngreso,
            mode: "rename",
            idCategoria: editingId,
          },
        });
      } else {
        this._doUpdateCategoria(editingId, editNombre.trim(), editColor, editEsIngreso, false);
      }
    });
  }

  addCategoria() {
    const { newNombre, newColor, newEsIngreso } = this.state;
    if (!newNombre.trim()) return;

    this.props.onLoading(true);
    this._searchSimilarAndThen(newNombre.trim(), (suggestions) => {
      this.props.onLoading(false);
      if (suggestions.length > 0) {
        this.setState({
          suggestionState: {
            suggestions,
            nombre: newNombre.trim(),
            color: newColor,
            esIngreso: newEsIngreso,
            mode: "add",
            idCategoria: null,
          },
        });
      } else {
        this._doAddCategoria(newNombre.trim(), newColor, newEsIngreso);
      }
    });
  }

  confirmDelete(cat) {
    this.setState({ deleteTarget: cat });
  }

  deleteCategoria() {
    const { deleteTarget } = this.state;
    this.setState({ deleteTarget: null });
    this.props.onLoading(true);

    const opts = { method: "DELETE" };
    doFetch("CCON", `deleteCategorias?IDCategoria=${deleteTarget.IDCategoria}`, opts)
      .then((r) => r.json())
      .then(() => this.loadCategorias())
      .catch(console.error)
      .finally(() => this.props.onLoading(false));
  }

  onSuggestionUseExisting(IDCategoria, Nombre) {
    const { suggestionState } = this.state;
    if (!suggestionState) return;
    if (suggestionState.mode === "add") {
      this._doAddCategoria(suggestionState.nombre, suggestionState.color, suggestionState.esIngreso, IDCategoria);
    } else {
      // rename: call update with exact suggested name so backend triggers merge
      this._doUpdateCategoria(suggestionState.idCategoria, Nombre, suggestionState.color, suggestionState.esIngreso, true);
    }
    this.setState({ suggestionState: null });
  }

  onSuggestionCreateAnyway() {
    const { suggestionState } = this.state;
    if (!suggestionState) return;
    this.setState({ suggestionState: null }, () => {
      if (suggestionState.mode === "add") {
        this._doAddCategoria(suggestionState.nombre, suggestionState.color, suggestionState.esIngreso);
      } else {
        this._doUpdateCategoria(suggestionState.idCategoria, suggestionState.nombre, suggestionState.color, suggestionState.esIngreso, false);
      }
    });
  }

  onSuggestionCancel() {
    this.setState({ suggestionState: null });
  }

  onMergeConfirm() {
    const { mergeState } = this.state;
    if (!mergeState) return;
    this._doUpdateCategoria(mergeState.idCategoria, mergeState.nombreDestino, mergeState.color, mergeState.esIngreso, true);
  }

  onMergeCancel() {
    this.setState({ mergeState: null });
  }

  closeModal = () => this.props.onClose();

  render() {
    const { categorias, editingId, editNombre, editColor, editEsIngreso, showNewRow, newNombre, newColor, newEsIngreso, deleteTarget, suggestionState, mergeState } = this.state;

    return (
      <>
        {suggestionState && (
          <CategoriaSuggestionModal
            suggestions={suggestionState.suggestions}
            nombrePropuesto={suggestionState.nombre}
            onUseExisting={(id, nombre) => this.onSuggestionUseExisting(id, nombre)}
            onCreateAnyway={() => this.onSuggestionCreateAnyway()}
            onCancel={() => this.onSuggestionCancel()}
          />
        )}
        {mergeState && (
          <MDBModal show={true} onHide={() => this.onMergeCancel()} tabIndex="-1">
            <MDBModalDialog size="sm" centered>
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>
                    <MDBIcon fas icon="exclamation-circle" className="me-2 text-danger" />
                    Fusionar categorías
                  </MDBModalTitle>
                </MDBModalHeader>
                <MDBModalBody>
                  El nombre ya existe como <strong>{mergeState.nombreDestino}</strong>. ¿Quieres fusionar tus transacciones con esa categoría?
                </MDBModalBody>
                <MDBModalFooter className="justify-content-between">
                  <MDBBtn color="light" size="sm" onClick={() => this.onMergeCancel()}>Cancelar</MDBBtn>
                  <MDBBtn color="danger" size="sm" onClick={() => this.onMergeConfirm()}>Sí, fusionar</MDBBtn>
                </MDBModalFooter>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>
        )}
        <MDBModal show={true} onHide={this.closeModal} tabIndex="-1">
          <MDBModalDialog size="lg" centered>
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>
                  <MDBIcon fas icon="tags" className="me-2" />
                  Gestión de categorías
                </MDBModalTitle>
                <MDBBtn className="btn-close" color="none" onClick={this.closeModal} />
              </MDBModalHeader>

              <MDBModalBody style={{ maxHeight: "60vh", overflowY: "auto" }}>
                <MDBTable align="middle" striped hover responsive className="categorias-modal-table">
                  <MDBTableHead>
                    <tr>
                      <th>Color</th>
                      <th>Nombre</th>
                      <th>Tipo</th>
                      <th>Transacciones</th>
                      <th>Acciones</th>
                    </tr>
                  </MDBTableHead>
                  <MDBTableBody>
                    {categorias.map((cat) =>
                      editingId === cat.IDCategoria ? (
                        <tr key={cat.IDCategoria} className="categorias-modal-row-editing">
                          <td>
                            <input
                              type="color"
                              className="categorias-modal-color-input"
                              value={editColor}
                              onChange={(e) => this.setState({ editColor: e.target.value })}
                            />
                          </td>
                          <td>
                            <MDBInput
                              value={editNombre}
                              onChange={(e) => this.setState({ editNombre: e.target.value })}
                              onKeyDown={(e) => { if (e.key === "Enter") this.saveEdit(); if (e.key === "Escape") this.cancelEdit(); }}
                              autoFocus
                            />
                          </td>
                          <td>
                            <label className="d-flex align-items-center gap-2 mb-0">
                              <input
                                type="checkbox"
                                checked={editEsIngreso}
                                onChange={(e) => this.setState({ editEsIngreso: e.target.checked })}
                              />
                              <span>{editEsIngreso ? "Ingreso" : "Gasto"}</span>
                            </label>
                          </td>
                          <td className="categorias-modal-tx-count">{cat.numTransacciones ?? 0}</td>
                          <td>
                            <MDBBtn size="sm" color="success" className="me-1" onClick={() => this.saveEdit()}>
                              <MDBIcon fas icon="check" />
                            </MDBBtn>
                            <MDBBtn size="sm" color="light" onClick={() => this.cancelEdit()}>
                              <MDBIcon fas icon="times" />
                            </MDBBtn>
                          </td>
                        </tr>
                      ) : (
                        <tr key={cat.IDCategoria}>
                          <td>
                            <span
                              className="categorias-modal-color-dot"
                              style={{ backgroundColor: cat.color || "#cccccc" }}
                              title={cat.color || "Sin color"}
                            />
                          </td>
                          <td>
                            {cat.nombre}
                            {cat.idUsuarioFK == null && (
                              <MDBBadge color="secondary" light pill className="categorias-modal-global-badge">
                                global
                              </MDBBadge>
                            )}
                          </td>
                          <td>
                            <MDBBadge color={this.normalizeIncomeFlag(cat.esIngreso) ? "success" : "danger"} light pill>
                              {this.normalizeIncomeFlag(cat.esIngreso) ? "Ingreso" : "Gasto"}
                            </MDBBadge>
                          </td>
                          <td className="categorias-modal-tx-count">{cat.numTransacciones ?? 0}</td>
                          <td>
                            {deleteTarget?.IDCategoria === cat.IDCategoria ? (
                              // Confirmación inline: evita anidar modales
                              <div className="d-flex align-items-center gap-1 flex-wrap">
                                <small className="text-danger me-1">
                                  {cat.numTransacciones > 0
                                    ? `¿Eliminar? (${cat.numTransacciones} tx)`
                                    : "¿Eliminar?"}
                                </small>
                                <MDBBtn size="sm" color="danger" className="me-1" onClick={() => this.deleteCategoria()}>
                                  <MDBIcon fas icon="check" className="me-1" />Sí
                                </MDBBtn>
                                <MDBBtn size="sm" color="light" onClick={() => this.setState({ deleteTarget: null })}>
                                  No
                                </MDBBtn>
                              </div>
                            ) : (
                              <>
                                <MDBBtn size="sm" color="link" className="me-1 p-1" title="Editar" onClick={() => this.startEdit(cat)}>
                                  <MDBIcon fas icon="edit" />
                                </MDBBtn>
                                <MDBBtn size="sm" color="link" className="text-danger p-1" title="Eliminar" onClick={() => this.confirmDelete(cat)}>
                                  <MDBIcon fas icon="trash" />
                                </MDBBtn>
                              </>
                            )}
                          </td>
                        </tr>
                      )
                    )}

                    {/* New row */}
                    {showNewRow && (
                      <tr className="categorias-modal-row-editing">
                        <td>
                          <input
                            type="color"
                            className="categorias-modal-color-input"
                            value={newColor}
                            onChange={(e) => this.setState({ newColor: e.target.value })}
                          />
                        </td>
                        <td>
                          <MDBInput
                            placeholder="Nombre de la categoría"
                            value={newNombre}
                            onChange={(e) => this.setState({ newNombre: e.target.value })}
                            onKeyDown={(e) => { if (e.key === "Enter") this.addCategoria(); if (e.key === "Escape") this.setState({ showNewRow: false }); }}
                            autoFocus
                          />
                        </td>
                        <td>
                          <label className="d-flex align-items-center gap-2 mb-0">
                            <input
                              type="checkbox"
                              checked={newEsIngreso}
                              onChange={(e) => this.setState({ newEsIngreso: e.target.checked })}
                            />
                            <span>{newEsIngreso ? "Ingreso" : "Gasto"}</span>
                          </label>
                        </td>
                        <td />
                        <td>
                          <MDBBtn size="sm" color="success" className="me-1" onClick={() => this.addCategoria()}>
                            <MDBIcon fas icon="check" />
                          </MDBBtn>
                          <MDBBtn size="sm" color="light" onClick={() => this.setState({ showNewRow: false })}>
                            <MDBIcon fas icon="times" />
                          </MDBBtn>
                        </td>
                      </tr>
                    )}
                  </MDBTableBody>
                </MDBTable>
              </MDBModalBody>

              <MDBModalFooter>
                {!showNewRow && (
                  <MDBBtn color="primary" onClick={() => this.setState({ showNewRow: true, editingId: null, newEsIngreso: false })}>
                    <MDBIcon fas icon="plus" className="me-1" />
                    Nueva categoría
                  </MDBBtn>
                )}
                <MDBBtn color="secondary" onClick={this.closeModal}>
                  Cerrar
                </MDBBtn>
              </MDBModalFooter>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      </>
    );
  }
}
